import React from 'react';
import ProjectList from '../components/ProjectList';
import './Projects.css';

const Projects = () => {
  return (
    <div className="page projects-page">
      <h1 className="page-title">Projects</h1>
      <p className="page-description">
        Things I have built in my spare time and put out into the world. Each one
        started as something I wanted for myself.
      </p>
      <ProjectList detailed />
    </div>
  );
};

export default Projects;
